/* eslint-disable import/prefer-default-export */
import { DPP_STATE } from '@educator/Container/AutoDPP/constants';
import eclipseItems from '@utils/eclipseItems';
import { isLessonLive } from '@models/Item';
import { pluralize } from '@utils/textHelper';
import { programmeTypes, batchTypes } from '@constants/index';

export const getAuthorsName = (authors, non_ta_author = false) => {
  let names = authors;
  if (!non_ta_author) {
    names = authors.filter((author) => !author.isTaAuthor);
  }
  names = names.map((author) => author.name);
  return eclipseItems(names);
};

export const getAuthorsList = (authors, non_ta_author = false) => {
  let filteredAuthors = authors;
  if (!non_ta_author) {
    filteredAuthors = authors.filter((author) => !author.isTaAuthor);
  }
  return filteredAuthors;
};

export const getLiveAndByWeekLessons = (lessons, liveClassList) => {
  const byWeek = {};
  const liveLesson = [];

  if (!lessons) {
    return { byWeek, liveLesson };
  }

  let lessonCount = 0;
  let quizCount = 0;
  let dppCount = 0;

  lessons.forEach((lesson) => {
    if (Object.entries(liveClassList).length) {
      if (liveClassList[lesson.uid]) {
        liveLesson.push(lesson);
      }
    } else if (isLessonLive(lesson)) {
      liveLesson.push(lesson);
    }
    if (lesson?.practiceDpp?.state === DPP_STATE.PUBLISHED) {
      dppCount += 1;
    }
    if (lesson.type === 'quiz') {
      quizCount += 1;
    } else {
      lessonCount += 1;
    }

    if (byWeek[lesson.week]) {
      byWeek[lesson.week].lessons.push(lesson);
      byWeek[lesson.week].quizCount = quizCount;
      byWeek[lesson.week].lessonCount = lessonCount;
      byWeek[lesson.week].dppCount = dppCount;
    } else {
      quizCount = 0;
      lessonCount = 0;
      dppCount = 0;

      if (lesson?.practiceDpp?.state === DPP_STATE.PUBLISHED) {
        dppCount += 1;
      }
      if (lesson.type === 'quiz') {
        quizCount += 1;
      } else {
        lessonCount += 1;
      }

      byWeek[lesson.week] = {
        lessons: [lesson],
        quizCount,
        lessonCount,
        dppCount
      };
    }
  });

  return { byWeek, liveLesson };
};

export const getCountInfo = (lessons, quizzes, isTestSeries) => {
  let infoString = '';
  if (lessons) infoString += pluralize(lessons, 'lesson');
  if (lessons && quizzes) infoString += ' • ';
  if (isTestSeries && quizzes) infoString += pluralize(quizzes, 'test');
  else if (quizzes) infoString += pluralize(quizzes, 'quiz', 'zes');
  return infoString;
};

export const isOfflineCourseType = (courseType) => {
  return courseType === programmeTypes.HYBRID_COURSE;
};

export const isOfflineTestSeries = (courseType) => {
  return courseType === programmeTypes.HYBRID_TESTSERIES;
};

export const isOfflineBatchType = (batchType) => {
  return batchType === batchTypes.CENTRE_BATCH;
};
